import {
  saveTodosStatus,
  sendEmail,
  tryNewEmail,
} from "@sourcewhale/shared/src/svelte/api/todos";
import { get } from "svelte/store";
import {
  saveStatusPayloadStore,
  todoPanelStore,
  todosModalItemStore,
} from "../stores";

const callback = async () => {
  const todo = get(todosModalItemStore);
  if (todo?.callback) {
    await todo.callback(todo);
  }
};

export const saveModalStatus = async () => {
  // Not a hot code path so using get is probably OK here.
  const data = get(saveStatusPayloadStore);
  return saveTodosStatus(data).then(callback);
};

export const approveEmail = async () => {
  const $todosModalItemStore = get(todosModalItemStore);
  const toDoIds = $todosModalItemStore ? [$todosModalItemStore.toDoId] : [];
  const $todoPanelStore = get(todoPanelStore);
  const { messageText, subject, attachmentIds } = $todoPanelStore;
  return sendEmail({ toDoIds, messageText, subject, attachmentIds }).then(
    callback,
  );
};

export const convertToEmail = async (attachmentIds = []) => {
  // Not a hot code path so get is fine here.  With svelte 5 we could
  // add some shared reactive state here and remove the svelte/get.
  const $todosModalItemStore = get(todosModalItemStore);
  const toDoIds = $todosModalItemStore ? [$todosModalItemStore.toDoId] : [];
  return sendEmail({ toDoIds, attachmentIds }).then(callback);
};

export const convertToInmail = async () => {
  const $todosModalItemStore = get(todosModalItemStore);
  return tryNewEmail({
    action: "convertToInmail",
    candidateId: $todosModalItemStore.candidateId,
    campaignId: $todosModalItemStore.campaignId,
  }).then(callback);
};

export const useNewEmail = async () => {
  const $todosModalItemStore = get(todosModalItemStore);
  const $todoPanelStore = get(todoPanelStore);

  const { successful } = await tryNewEmail({
    newEmail: $todoPanelStore.newEmail,
    candidateId: $todosModalItemStore.candidateId,
    campaignId: $todosModalItemStore.campaignId,
  });
  if (successful) {
    return callback();
  }
  todoPanelStore.set({
    ...$todoPanelStore,
    invalidEmail: $todoPanelStore.newEmail,
  });
  return null;
};
